import { useContext, useMemo } from 'react'

import { OptionalMiddlewareContext, OptionalMiddlewareContextProps } from '../OptionalMiddlewareContext'

export const useOptionalFetchMiddleware = (optionalMiddleware?: OptionalMiddlewareContextProps) => {
  const parentContext = useContext(OptionalMiddlewareContext)
  return useMemo(() => {
    return {
      ...parentContext,
      ...(optionalMiddleware ?? {}),
    }
  }, [optionalMiddleware, parentContext])
}
